import PropTypes from 'prop-types';
import compose from 'lodash.flowright';

import { mapProps } from '../../../../util/hocs';
import withModal from '../../../../components/global/modal/withModal';
import PrintProductConfigurator from './PrintProductConfigurator';
import { ORIENTATION } from '../../../cards/constants';

export const PRINT_PRODUCT_CONFIGURATOR_MODAL =
  'PRINT_PRODUCT_CONFIGURATOR_MODAL';

const propTypes = {
  printProductId: PropTypes.string.isRequired,
  printProductSizeId: PropTypes.string,
  orientation: PropTypes.oneOf(Object.values(ORIENTATION)),
  photoId: PropTypes.string,
};

const PrintProductConfiguratorModal = withModal(
  compose(
    mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
      onClose: onRequestClose,
      ...actionProps,
      ...props,
    })),
  )(PrintProductConfigurator),
  {
    name: PRINT_PRODUCT_CONFIGURATOR_MODAL,
    dismissible: false,
    type: 'full',
    hideHeader: true,
    className: 'print-product-configurator-modal',
  },
);

PrintProductConfiguratorModal.propTypes = propTypes;

export default PrintProductConfiguratorModal;
